import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class PassingModel extends Model 
{
	@attr chip;
	@attr time;
	@attr frameTime;
	
	@belongsTo('activator',{inverse: null, async: true}) ActivatorId;
}